const THRESHOLD = 100;

/**
 * ヘッダーのスクロールアクション
 * スクロール量が閾値を超えたら header に action クラスを付与
 */
export const headerScroll = {
  init: () => {
    const header = document.getElementById('header');
    if (!header) return;

    const updateHeader = () => {
      if (window.scrollY > THRESHOLD) {
        header.classList.add('action');
      } else {
        header.classList.remove('action');
      }
    };

    window.addEventListener('scroll', updateHeader, { passive: true });
    updateHeader();
  },
};
